module.exports = __webpack_public_path__ + "img/surveillance-camera.722915ab.svg";